import React from 'react';
import {
    PopupAskForConfirmationContainer,
    PopupAskForConfirmationContent,
} from './styles';
import {useTranslation} from "react-i18next";
import {SecondaryButton} from "../SecondaryButton";
import {Modal} from "../Modal";
import {PopupIcon} from "../PopupIcon";
import {PrimaryButton} from "../PrimaryButton";
import {FeedbackTypes} from "../../app/interfaces";
interface PopupAskForActionsConfirmationProps{
    isOpen: boolean,
    title?: string,
    subtitle?: string,
    confirmButtonTitle?: string,
    cancelButtonTitle?: string
    onConfirm: Function,
    onCancel: Function
    type?: FeedbackTypes,
}

export const PopupAskForConfirmation = ({isOpen, title, subtitle, confirmButtonTitle, cancelButtonTitle, onConfirm, onCancel, type='info'}: PopupAskForActionsConfirmationProps) => {
    const {t} = useTranslation()

    return <Modal isOpen={isOpen}>
        <PopupAskForConfirmationContainer>
            <PopupAskForConfirmationContent>
                <PopupIcon type={type}/>
                {title && <h1>{title}</h1>}
                {subtitle && <p>{subtitle}</p>}
                <section>
                    <SecondaryButton onClick={() => onCancel()}>
                        {cancelButtonTitle ? cancelButtonTitle : t('cancel')}
                    </SecondaryButton>
                    <PrimaryButton onClick={() => onConfirm()}>
                        {confirmButtonTitle ? confirmButtonTitle : t('confirm')}
                    </PrimaryButton>
                </section>
            </PopupAskForConfirmationContent>
        </PopupAskForConfirmationContainer>
    </Modal>
}
